import { render, staticRenderFns } from "./NexusDepositList.vue?vue&type=template&id=aed0d742&"
import script from "./NexusDepositList.vue?vue&type=script&lang=js&"
export * from "./NexusDepositList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports